import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSocketContext } from "./SocketContext";
import { toast } from "react-toastify";
import welcomeMessage from "./assets/audios/messageTone.mp3";
import errorTone from "./assets/audios/error_tone.mp3";
import ProfileImage from "./components/ProfileImage";
import { setFoodList } from "./slices/foodListSlice";
import { setCredentials } from "./slices/authSlice";

const useListenMessages = () => {
  const { socketDetails: socket } = useSocketContext();
  const { userInfo } = useSelector((state) => state.auth);
  const [isToggled, setIsToggled] = useState(userInfo?.audioOn);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!socket) return;
    const handleNewMessage = (updatedItemDetails) => {
      // console.log(new Date().getMinutes() + " : " + new Date().getSeconds());
      // console.log(updatedItemDetails?.updatedItemCount);
      toast.success("new data available : ");
      if (updatedItemDetails?.updatedItemCount?.length > 0) {
        dispatch(setFoodList(updatedItemDetails?.updatedItemCount));
      }
    };

    const handleOrderStatusUpdate = (updatedItemDetails) => {
      // console.log(new Date().getMinutes() + " : " + new Date().getSeconds());
      // console.log("updatedItemDetails status");
      // console.log(updatedItemDetails);
      toast.success("Order status is Changed");
      if (updatedItemDetails) {
        dispatch(
          setCredentials({ ...userInfo, lastOrder: updatedItemDetails })
        );
      }
    };

    // Attach listener
    socket.on("item_availability_update", handleNewMessage);
    socket.on("order_status_update", handleOrderStatusUpdate);

    // Cleanup listener
    return () => {
      socket.off("item_availability_update", handleNewMessage);
      socket.off("order_status_update", handleOrderStatusUpdate);
    };
  }, [socket]);
};
export default useListenMessages;
